import React from 'react'


const Dashboard = () => {
    return (
        <div>
            <div className="wrapper">
            </div>
        </div>
    )
}

export default Dashboard
